import { Breadcrumbs, Typography } from "@mui/material";
import Link from "next/link";
import { BreadcrumbList, Graph, ListItem } from "schema-dts";
import { WEB_URL_BASE } from "@/app/layout/LayoutConstants";

export const HUB_BREADCRUMBS = {
  hub: { label: "Horsezone Hub", url: "/hub" },
};

export function CategoryToBreadcrumb(category: string): { label: string; url: string } {
  return {
    label: category.charAt(0).toUpperCase() + category.slice(1).toLowerCase(),
    url: `/hub/${category.toLowerCase()}`,
  };
}

export function HubBreadcrumbs({
  breadcrumbs,
}: {
  breadcrumbs: { label: string; url: string }[];
}) {
  const breadcrumbSchema: BreadcrumbList = {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: WEB_URL_BASE + "/",
      },
      ...breadcrumbs.map(
        (breadcrumb, index): ListItem => ({
          "@type": "ListItem",
          position: index + 2,
          name: breadcrumb.label,
          item:
            index < breadcrumbs.length - 1
              ? WEB_URL_BASE + breadcrumb.url
              : undefined,
        }),
      ),
    ],
  };
  const graph: Graph = {
    "@context": "https://schema.org",
    "@graph": [breadcrumbSchema],
  };

  return (
    <>
      <Breadcrumbs
        sx={(theme) => ({
          ...theme.typography.caption,
          padding: theme.spacing(0, 4),
          [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(0, 2),
          },
        })}
      >
        <Link href="/">Home</Link>
        {breadcrumbs.slice(0, -1).map((breadcrumb) => (
          <Link key={breadcrumb.url} href={breadcrumb.url}>
            {breadcrumb.label}
          </Link>
        ))}
        <Typography aria-current="page" variant="caption">
          {breadcrumbs[breadcrumbs.length - 1].label}
        </Typography>
      </Breadcrumbs>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(graph) }}
      />
    </>
  );
}
